import React, { createContext, useContext, useEffect, useState } from 'react';
import { TWAConfig } from './config';
import { ParsedTWAConfig, parseConfig } from './parsedConfig';


const getUrlToConfig = () => {
    //if this is localhost, return the local config
    if (window.location.hostname === "localhost") {
        return "/config/twa-timer-config.json";
    } else if (window.location.hostname.includes("test") || window.location.hostname.includes("prelive")) {
        return "https://firebasestorage.googleapis.com/v0/b/the-writing-academic-timer.appspot.com/o/public%2Fconfig%2Ftwa-timer-config.prelive.json?alt=media";
    } else {
        return "https://firebasestorage.googleapis.com/v0/b/the-writing-academic-timer.appspot.com/o/public%2Fconfig%2Ftwa-timer-config.live.json?alt=media";
    }
}

const ConfigContext = createContext<ParsedTWAConfig | undefined>(undefined);

// Erstelle den ConfigProvider
export const ConfigProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const [config, setConfig] = useState<ParsedTWAConfig | undefined>(undefined);

    useEffect(() => {
        // Lade die JSON-Datei
        fetch(getUrlToConfig())
            .then((response) => response.json())
            .then((data: TWAConfig) => setConfig(parseConfig(data)))
            .catch((error) => console.error('Fehler beim Laden der Konfigurationsdatei:', error));
    }, []);

    if (!config) {
        return (
            <div className="not-found fullsize">
                
            </div>
        );
    }

    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

// Erstelle einen Custom Hook, um auf die Konfiguration zuzugreifen
export const useConfig: () => ParsedTWAConfig = () => {
    const config = useContext(ConfigContext);
    if (!config) {
        throw new Error('useConfig muss innerhalb eines ConfigProviders verwendet werden');
    }
    return config;
};